import type { StocksStatusLightID } from '@/models/ids';
import type { Timestamps } from '@/models/base-types';

// StocksStatusLightColor represents the possible states of the traffic light
export type StocksStatusLightColor = 'GREEN' | 'YELLOW' | 'RED';

// Const object for StocksStatusLightColor values (replaces enum)
export const StocksStatusLightColor = {
  GREEN: 'GREEN' as const,
  YELLOW: 'YELLOW' as const,
  RED: 'RED' as const
} as const;

// StocksStatusLight represents the current market status indicator
export interface StocksStatusLight extends Timestamps {
  id: StocksStatusLightID;
  color: StocksStatusLightColor;
  comment: string;
  deleted: string | null;
}

// Sort fields for StocksStatusLight
export type StocksStatusLightSort = 'created' | 'updated';
